module.exports = __webpack_public_path__ + "static/b1-b26c149b7f0e3830cd537a4eebd46a6e.jpg";